export default [
  'title',
  'status',
  'purchaseTime',
  'systemCode',
  'destinationItemId',
  'sourceItemCode',
  'buyerName',
  'buyerUsername',
  'buyerEmail',
  'salePrice',
  'sourcePrice',
  'profit',
  'quantity',
  'destinationOrderNumber',
  'destinationAccount',
];
